export const CLOSEOUT_CATS_SET = 'CLOSEOUT_CATS_SET';
export const CLOSEOUT_SET = 'CLOSEOUT_SET';
export const CLOSEOUT_CONTRIBS_SET = 'CLOSEOUT_CONTRIBS_SET';
export const CLOSEOUT_CONTRIB_SET = 'CLOSEOUT_CONTRIB_SET';
export const CLOSEOUT_PERCENTAGE_SET = 'CLOSEOUT_PERCENTAGE_SET';
export const CLOSEOUT_MANUALS_SET = 'CLOSEOUT_MANUALS_SET';
export const CLOSEOUT_MANUAL_SET = 'CLOSEOUT_MANUAL_SET';
export const CLOSEOUT_MANUAL_UPDATE = 'CLOSEOUT_MANUAL_UPDATE';
export const CLOSEOUT_MANUAL_DELETE = 'CLOSEOUT_MANUAL_DELETE';



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-closeout/store/action-types.js